module.exports = __webpack_public_path__ + "static/media/range_3_red.3fcd5eac.png";